import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=0fdd0cee&"
import script from "./Words.vue?vue&type=script&lang=ts&"
export * from "./Words.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports